import SvgCookieFallback from '@icons/svgCookieFallback';
import * as React from 'react';

export interface ICookiesBlockedPlaceholderProps {
    text: string;
    buttonText: string;
    icon?: string;
}

export default function CookiesBlockedPlaceholder({ text, buttonText, icon }: ICookiesBlockedPlaceholderProps) {
    const renew = () => {
        // we disabled eslint because this function exist outside of this file via script in the _Layout.cshtml
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        CookieConsent.renew();
    };

    return (
        <div className="fa-cookies-blocked-placeholder">
            <div className="fa-cookies-blocked-placeholder__content">
                <span className="fa-cookies-blocked-placeholder__content__icon">
                    {icon ? <img src={icon} alt="Cookie icon" /> : <SvgCookieFallback />}
                </span>
                <p className="fa-cookies-blocked-placeholder__content__text">
                    {text ? text : 'You must accept functional cookies to watch this video'}
                </p>
                <div>
                    <button
                        onClick={renew}
                        className="fa-cookies-blocked-placeholder__content__button fa-atom-button"
                    >
                        {buttonText ? buttonText : 'Update cookie settings'}
                    </button>
                </div>
            </div>
        </div>
    );
}
